import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';

/**
 * STEL-1440: Sapotan Video Attachment
 * Dialog full-screen player video.
 * Pattern: ref-based API giống DialogShowImage.js
 *
 * Usage:
 *   <DialogShowVideo ref={(dialog) => (this.dialogShowVideo = dialog)} />
 *   this.dialogShowVideo.openDialog(videoUrl)
 */
export default class DialogShowVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      videoUrl: '',
    };
    this.videoRef = React.createRef();
  }

  openDialog = (videoUrl) => {
    this.setState({ show: true, videoUrl });
  };

  closeDialog = () => {
    // Reset video về 0:00 trước khi đóng
    if (this.videoRef.current) {
      this.videoRef.current.pause();
      this.videoRef.current.currentTime = 0;
    }
    this.setState({ show: false, videoUrl: '' });
  };

  render() {
    const { show, videoUrl } = this.state;

    return (
      <Dialog
        modal={false}
        open={show}
        className="dialogShowImage"
        onRequestClose={this.closeDialog}
      >
        <i
          className="material-icons tab__icons closeBlock closeImageShow"
          onClick={this.closeDialog}
        >
          clear
        </i>
        {videoUrl ? (
          <video
            ref={this.videoRef}
            src={videoUrl}
            controls
            autoPlay
            style={{ maxWidth: '100%', maxHeight: '70vh', display: 'block', margin: '0 auto', outline: 'none', border: 'none' }}
          />
        ) : null}
      </Dialog>
    );
  }
}
